<form
  name="form"
  autocomplete="off"
  class="tab-locations field-dialog__content__scroll"
  [class.with-disclaimer]="isViewMode"
  fusePerfectScrollbar
>
  <disclaimer *ngIf="isViewMode" [message]="'GROUPS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
  <disclaimer *ngIf="!isViewMode" [message]="'GROUPS.DIALOG.TABS.LOCATIONS.DISCLAIMER' | translate"> </disclaimer>

  <div class="field-outline-form">
    <div class="search-bar">
      <mat-form-field class="search-bar__input" appearance="outline">
        <mat-label> {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.SEARCH' | translate }}</mat-label>
        <mat-icon matPrefix color="primary">search</mat-icon>
        <input matInput [formControl]="searchInput" (keydown)="$event.stopImmediatePropagation()" />
        <mat-hint> {{ 'GROUPS.DIALOG.TABS.LOCATIONS.SEARCH_SUGGESTION' | translate }}</mat-hint>
      </mat-form-field>

      <button
        class="search-bar__button"
        color="primary"
        mat-raised-button
        *ngIf="!isViewMode"
        (click)="openLinkLocationsDialog()"
      >
        {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="tab-locations__title-wrapper">
    <p class="tab-locations__title-text">
      {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.TITLE' | translate }} ({{ page?.totalCount || 0 }})
    </p>
  </div>

  <ng-container *ngIf="isLoading; else pageTemplate">
    <div class="loading">
      <mat-spinner class="loading__spinner" diameter="64"></mat-spinner>
      <span class="loading__text"> {{ 'GROUPS.DIALOG.TABS.LOCATIONS.LOADING' | translate }}</span>
    </div>
  </ng-container>

  <ng-template #pageTemplate>
    <div class="tab-locations__body">
      <ng-container *ngIf="page?.items.length; else noLocations">
        <div
          class="card tab-locations__body__card"
          *ngFor="let location of page.items"
          fxLayout="row"
          fxLayout="space-between center"
          fxLayoutGap="16px"
        >
          <div fxLayout="column" fxFlex fxLayoutAlign="center start">
            <p class="tab-locations__body__card__name" [class.archived]="location.archived">
              {{ location.name }}
              <span *ngIf="location.archived">({{ 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.ARCHIVED' | translate }})</span>
            </p>

            <p class="tab-locations__body__card__email">
              {{ location.address.formattedAddress | removeLocationName: location.name }}
            </p>
          </div>

          <div *ngIf="!isViewMode">
            <div style="width: 40px; height: 40px; display: grid; place-items: center" *ngIf="location['isSaving']">
              <mat-spinner color="primary" diameter="20"></mat-spinner>
            </div>
            <button
              class="tab-locations__body__card__remove"
              matTooltipPosition="left"
              mat-icon-button
              *ngIf="!location['isSaving'] && !group.locked"
              [matTooltip]="'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.UNLINK' | translate"
              [disabled]="location['isSaving']"
              (click)="removeLocationFroGroup(location)"
            >
              <i class="angularjs-fuse-icon icon-delete"></i>
            </button>
          </div>
        </div>
        <div class="tab-locations__paginator-wrapper">
          <fc-paginator
            class="tab-locations__paginator"
            #paginator
            [pageSize]="pageSize"
            [totalCount]="page?.totalCount"
            [currentPageLength]="page?.items.length"
            [isLoading]="isPageChanging"
            (page)="onPageChange($event)"
          >
          </fc-paginator>
        </div>
      </ng-container>
      <ng-template #noLocations>
        <p *ngIf="!page?.items.length" class="tab-locations__body__not-found-title">
          <mat-icon>search</mat-icon>
          {{
            (searchInput.value
              ? 'GROUPS.DIALOG.TABS.LOCATIONS.LINK.NOT_FOUND'
              : 'GROUPS.DIALOG.TABS.LOCATIONS.LINKED.NOT_FOUND'
            ) | translate
          }}
        </p>
      </ng-template>
    </div>
  </ng-template>
</form>
